import Icon from '../components/Icon.vue'

Icon.register({
  'digital-tachograph': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M608 96H32C14.3 96 0 110.3 0 128V384C0 401.7 14.3 416 32 416H608C625.7 416 640 401.7 640 384V128C640 110.3 625.7 96 608 96zM304 352C304 356.4 300.4 360 296 360H72C67.6 360 64 356.4 64 352V344C64 339.6 67.6 336 72 336H296C300.4 336 304 339.6 304 344V352zM72 288V272C72 267.6 75.6 264 80 264H96C100.4 264 104 267.6 104 272V288C104 292.4 100.4 296 96 296H80C75.6 296 72 292.4 72 288zM136 288V272C136 267.6 139.6 264 144 264H160C164.4 264 168 267.6 168 272V288C168 292.4 164.4 296 160 296H144C139.6 296 136 292.4 136 288zM200 288V272C200 267.6 203.6 264 208 264H224C228.4 264 232 267.6 232 272V288C232 292.4 228.4 296 224 296H208C203.6 296 200 292.4 200 288zM264 288V272C264 267.6 267.6 264 272 264H288C292.4 264 296 267.6 296 272V288C296 292.4 292.4 296 288 296H272C267.6 296 264 292.4 264 288zM304 224C304 232.8 296.8 240 288 240H80C71.2 240 64 232.8 64 224V176C64 167.2 71.2 160 80 160H288C296.8 160 304 167.2 304 176V224zM576 352C576 356.4 572.4 360 568 360H344C339.6 360 336 356.4 336 352V344C336 339.6 339.6 336 344 336H568C572.4 336 576 339.6 576 344V352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/digital-tachograph.js
// module id = SBrL
// module chunks = 144